import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import TrashCanIcon from "../../../../../../assets/icons/TrashCanIcon";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";

export default function DeleteCarrierContactAction({ activeCarrier, originPoint, contact, contactUpdated, actionCallback }) {
  return (
    <StyledTooltip title="Delete">
      <Box>
        <InlineIconButton
          onClick={() => actionCallback({
            action: "delete-carrier-contact", 
            activeCarrier: activeCarrier, 
            originPoint: originPoint, 
            contact: contact,
            contactUpdated: contactUpdated
          })}
          icon={TrashCanIcon}
          buttonColor="blue"
        />
      </Box>
    </StyledTooltip>
  );
}

DeleteCarrierContactAction.propTypes = {
  activeCarrier: PropTypes.object,
  originPoint: PropTypes.string,
  contact: PropTypes.object.isRequired,
  contactUpdated: PropTypes.func,
  actionCallback: PropTypes.func.isRequired
};